import cookies from 'js-cookie';

export const setSecureCookie = (key: string, value: string) =>
  cookies.set(key, value, {
    SameSite: 'lax',
    expires: 14,
    secure: window.location.protocol === 'https:',
  } as any);
